<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 v-html="header"></h2>
       <v-divider class="mb-4"></v-divider>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'HeaderPartial',
  props: ['header'],
  data () {
    return {}
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partials/BreadCrumpPartial.vue